import { FIFA_COUNTRY_CODES } from '@/constants/fifaCountryCodes'

const GB_REGION_MAP: Record<string, string> = {
  ENG: 'gb-eng',
  NIR: 'gb-nir',
  SCO: 'gb-sct',
  WAL: 'gb-wls'
}

/**
 * Convert FIFA country code to alpha-2 code for CircleFlag component
 * FIFA codes like RSA, ENG, SCO, USA are used by golf WebSocket data
 */
export function convertFifaCodeToAlpha2(fifaCode: string | undefined | null): string {
  if (!fifaCode) {
    return 'xx' // Unknown flag
  }

  const upperCode = fifaCode.toUpperCase()

  if (upperCode in GB_REGION_MAP) {
    return GB_REGION_MAP[upperCode]
  }

  const countryData = FIFA_COUNTRY_CODES[upperCode]
  if (countryData) {
    return countryData.alpha2.toLowerCase()
  }

  console.warn(`Unknown country code: ${upperCode}`)
  return 'xx'
}

export function getCountryNameFromFifaCode(fifaCode: string | undefined | null): string {
  if (!fifaCode) {
    return 'Unknown'
  }

  const upperCode = fifaCode.toUpperCase()

  const countryData = FIFA_COUNTRY_CODES[upperCode]
  if (countryData) {
    return countryData.country
  }

  console.warn(`Unknown country code: ${upperCode}`)
  return 'Unknown'
}
